module.exports = __webpack_public_path__ + "static/media/receiveProd.084efe9b.svg";